export const ADD_PENDING_FIELD_COMMENT = 'ADD_PENDING_FIELD_COMMENT';
export const REMOVE_PENDING_FIELD_COMMENT = 'REMOVE_PENDING_FIELD_COMMENT';
export const NORMALIZED_COMMENT_CHANGES_REQUESTED =
  'NORMALIZED_COMMENT_CHANGES_REQUESTED';
export const DISMISS_NORMALIZED_COMMENT = 'DISMISS_NORMALIZED_COMMENT';
export const DISMISS_SUGGESTION = 'DISMISS_SUGGESTION';
export const ACCEPT_SUGGESTION = 'ACCEPT_SUGGESTION';
